import { getConstanceSettings } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

export const useSegmentSelectionEnabled = (): boolean => {
  const constanceSettings = useSelector(getConstanceSettings)
  return Boolean(constanceSettings?.SIMSEARCH_SEGMENT_SELECTION)
}
